export const CPRNG_FEATURES_KEY = 'cprng_features';

export const CPRNG_FEATURE_DUNA_SIMULATOR = 'duna_simulator';
export const CPRNG_FEATURE_DUNA_STATS = 'duna_stats';

export interface CprngFeatureEntry {
  org_enabled: boolean;
  location_ids: number[];
}

export const CPRNG_FEATURE_DEFS: {
  key: string;
  label: string;
}[] = [
  { key: CPRNG_FEATURE_DUNA_SIMULATOR, label: 'DUNA Simulator' },
  { key: CPRNG_FEATURE_DUNA_STATS, label: 'DUNA Stats' },
];

export function defaultCprngFeatureEntry(): CprngFeatureEntry {
  return { org_enabled: false, location_ids: [] };
}

export function normalizeCprngFeaturesFromOrgData(
  data: Record<string, unknown> | null | undefined
): Record<string, CprngFeatureEntry> {
  const raw = data?.[CPRNG_FEATURES_KEY];
  const out: Record<string, CprngFeatureEntry> = {};
  for (const def of CPRNG_FEATURE_DEFS) {
    out[def.key] = parseFeatureEntry(
      raw && typeof raw === 'object' && !Array.isArray(raw)
        ? (raw as Record<string, unknown>)[def.key]
        : undefined
    );
  }
  return out;
}

function parseFeatureEntry(value: unknown): CprngFeatureEntry {
  const entry = defaultCprngFeatureEntry();
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return entry;
  }
  const obj = value as Record<string, unknown>;
  if (typeof obj['org_enabled'] === 'boolean') {
    entry.org_enabled = obj['org_enabled'];
  }
  if (Array.isArray(obj['location_ids'])) {
    entry.location_ids = obj['location_ids']
      .map((id) => (typeof id === 'number' ? id : parseInt(String(id), 10)))
      .filter((id) => !Number.isNaN(id) && id > 0);
  }
  return entry;
}

export function buildCprngFeaturesPayload(
  state: Record<string, CprngFeatureEntry>
): Record<string, CprngFeatureEntry> {
  const payload: Record<string, CprngFeatureEntry> = {};
  for (const def of CPRNG_FEATURE_DEFS) {
    const s = state[def.key] ?? defaultCprngFeatureEntry();
    payload[def.key] = {
      org_enabled: s.org_enabled,
      location_ids: [...s.location_ids],
    };
  }
  return payload;
}
